import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Award } from "lucide-react";

const Certifications = ({ certifications, education }) => {
  return (
    <section id="credentials" className="py-24 md:py-32 border-t border-white/10" data-testid="certifications-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-20">
        <div>
          <p className="font-mono text-xs tracking-[0.3em] text-emerald-400 mb-4 flex items-center gap-2">
            <Award className="h-4 w-4" /> CERTIFICATIONS & TRAINING
          </p>
          <h2 className="font-display text-3xl text-gray-100 mb-12">Credentials</h2>
          <ul className="divide-y divide-white/10 border-y border-white/10">
            {certifications?.map((cert, i) => (
              <motion.li
                key={cert.id}
                className="py-5 flex items-baseline gap-6 group"
                initial={{ opacity: 0, x: -10 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.06 }}
                viewport={{ once: true }}
                data-testid={`certification-item-${cert.id}`}
              >
                <span className="font-mono text-xs text-emerald-500/70 shrink-0">[{String(i + 1).padStart(2, "0")}]</span>
                <div>
                  <p className="text-gray-100 text-sm group-hover:text-emerald-400 transition-colors">{cert.name}</p>
                  <p className="font-mono text-xs text-gray-600 mt-1 uppercase tracking-wider">{cert.issuer}</p>
                </div>
              </motion.li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono text-xs tracking-[0.3em] text-emerald-400 mb-4 flex items-center gap-2">
            <GraduationCap className="h-4 w-4" /> EDUCATION
          </p>
          <h2 className="font-display text-3xl text-gray-100 mb-12">Foundations</h2>
          <div className="space-y-px bg-white/10 border border-white/10">
            {education?.map((edu) => (
              <div key={edu.id} className="bg-[#0a0a0a] p-8 hover:bg-[#0d0d0d] transition-colors" data-testid={`education-item-${edu.id}`}>
                <p className="text-gray-100">{edu.degree}</p>
                <p className="font-mono text-xs text-gray-500 mt-2 uppercase tracking-wider">{edu.institution}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 border border-emerald-500/30 p-8" data-testid="languages-card">
            <p className="font-mono text-xs tracking-[0.3em] text-emerald-400 mb-4">LANGUAGES</p>
            <p className="text-sm text-gray-400">English — Professional · Hindi — Native</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
